import StorageHelper from '../../utils/StorageHelper';
import { STORAGE_KEYS } from '../../configs/AppConfig';

export const isAuthenticated = state => state.session.isAuthenticated;
export const isSessionValidating = state => state.session.isSessionValidating;
// export const getToken = state => StorageHelper.getSessionItem(STORAGE_KEYS.session);
export const getToken = state => StorageHelper.getCookie(STORAGE_KEYS.session);
export const getAuthUser = state => state.session.user;
